

import React from "react";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";

function ButtonContainer({ handleNext, isSubmit = false, handlePrevious, mode }) {
  const showPrevious = mode === "create"; 

  const getMainButtonLabel = () => {
    if (isSubmit) return "Submit";
    if (mode === "create") return "Confirm & Next";
    if (mode === "edit") return "Update & Next";
    return "Next";
  };

  return (
    <div className="flex justify-center w-full mt-6">
      <div className="flex">
        {showPrevious && (
          <div className="mr-2">
            <CustomButton
              onClick={handlePrevious}
              customeClass="primary-custom-button w-[150px] h-[40px]"
            >
              Previous
            </CustomButton>
          </div>
        )}
        <div>
          <CustomButton
            onClick={handleNext}
            customeClass={`gradient-button ${isSubmit ? "w-[180px]" : "w-[150px]"} h-[40px]`}
          >
            {getMainButtonLabel()}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default ButtonContainer;
